import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function FilterIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.01998C3.13002 8.38998 2.65002 7.30998 2.65002 6.49998V4.19998C2.65002 2.59998 3.86002 1.34998 5.40002 1.34998H18.6C20.12 1.34998 21.35 2.57998 21.35 4.09998V6.29998C21.35 7.34998 20.72 8.53998 20.13 9.12998L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.84998C4.70002 2.84998 4.15002 3.43998 4.15002 4.19998V6.49998C4.15002 6.86998 4.45002 7.58998 4.83002 7.96998L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.02998C19.45 7.68998 19.86 6.87998 19.86 6.28998V4.09998C19.86 3.40998 19.3 2.84998 18.61 2.84998H5.40002Z'
                fill='white'
            />
            <path
                d='M5.99998 10.75C5.85998 10.75 5.72998 10.71 5.59998 10.64C5.24998 10.42 5.13998 9.95002 5.35998 9.60002L10.29 1.70002C10.51 1.35002 10.97 1.24002 11.32 1.46002C11.67 1.68002 11.78 2.14002 11.56 2.49002L6.62998 10.39C6.48998 10.62 6.24998 10.75 5.99998 10.75Z'
                fill='white'
            />
        </svg>
    );
}

export default FilterIcon;

